export interface IconDollarGradientProps {
	testId?: string;
}

const IconDollarGradient = (props: IconDollarGradientProps) => {
	const { testId = 'IconDollarGradient' } = props;

	return (
		<svg
			data-testid={testId}
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 36 36"
			aria-label="Dollar Sign Icon"
		>
			<path
				fill="url(#icon_dollar_gradient)"
				d="M17.991 35.991c-2.461 0-4.778-.47-6.949-1.41a18.146 18.146 0 0 1-5.747-3.884 18.538 18.538 0 0 1-3.884-5.748C.47 22.778 0 20.462 0 18c0-2.461.47-4.778 1.41-6.95a18.327 18.327 0 0 1 3.885-5.73c1.66-1.66 3.57-2.96 5.73-3.9C13.195.478 15.512.008 17.974.008c2.473 0 4.795.47 6.966 1.41a18.39 18.39 0 0 1 5.748 3.902 18.184 18.184 0 0 1 3.901 5.73C35.53 13.222 36 15.539 36 18c0 2.462-.47 4.778-1.41 6.95a18.392 18.392 0 0 1-3.902 5.747 18.146 18.146 0 0 1-5.747 3.884c-2.172.94-4.488 1.41-6.95 1.41Zm0-3.553c2.009 0 3.884-.371 5.626-1.114a14.47 14.47 0 0 0 4.598-3.1 14.469 14.469 0 0 0 3.1-4.598c.743-1.742 1.115-3.617 1.115-5.626 0-1.997-.372-3.867-1.115-5.608a14.416 14.416 0 0 0-7.716-7.716c-1.741-.743-3.616-1.114-5.625-1.114-1.997 0-3.872.371-5.626 1.114a14.268 14.268 0 0 0-4.58 3.1 14.56 14.56 0 0 0-3.083 4.616C3.942 14.134 3.57 16.002 3.57 18c0 2.009.372 3.884 1.115 5.626a14.614 14.614 0 0 0 3.083 4.598 14.47 14.47 0 0 0 4.598 3.1c1.753.743 3.628 1.114 5.625 1.114Zm-.017-4.65a.791.791 0 0 1-.558-.209.8.8 0 0 1-.226-.592v-1.184c-1.242-.117-2.299-.476-3.17-1.08-.859-.604-1.41-1.376-1.654-2.317a4.036 4.036 0 0 1-.087-.296 2.392 2.392 0 0 1-.018-.296c0-.348.105-.627.314-.836.22-.22.51-.33.87-.33.29 0 .535.08.732.243.21.151.372.378.488.68.14.522.418.963.836 1.323s.98.592 1.69.697v-4.633l-.28-.07c-1.45-.325-2.548-.83-3.291-1.515-.743-.697-1.115-1.608-1.115-2.734 0-1.208.435-2.2 1.306-2.979.883-.79 2.009-1.254 3.38-1.393V9.1c0-.534.26-.801.783-.801.232 0 .424.075.575.226.15.14.226.331.226.575v1.167c1.161.116 2.148.476 2.96 1.08.825.604 1.36 1.358 1.603 2.264.023.093.04.192.052.296.024.093.035.192.035.296 0 .337-.11.61-.33.819-.21.209-.494.313-.854.313-.557 0-.964-.302-1.22-.905a2.779 2.779 0 0 0-.835-1.272c-.383-.325-.854-.54-1.411-.644v4.371l.383.087c1.51.28 2.642.773 3.396 1.48.767.71 1.15 1.661 1.15 2.857 0 1.312-.47 2.357-1.41 3.135-.93.778-2.102 1.237-3.519 1.376v1.167a.8.8 0 0 1-.226.592.814.814 0 0 1-.575.21Zm-.784-11.303v-3.989c-.673.117-1.207.354-1.602.714-.383.36-.575.784-.575 1.272 0 .464.168.86.505 1.184.337.314.854.575 1.55.784l.122.035Zm1.585 2.873v4.233c.801-.093 1.4-.325 1.794-.697.406-.383.61-.853.61-1.41 0-.5-.157-.912-.47-1.237-.303-.337-.837-.61-1.603-.819l-.331-.07Z"
			/>
			<defs>
				<linearGradient
					id="icon_dollar_gradient"
					x1="10.93"
					x2="64.294"
					y1="-34.475"
					y2="-7.972"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FB923C" />
					<stop offset=".5" stopColor="#EC4899" />
					<stop offset="1" stopColor="#0EA5E9" />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default IconDollarGradient;
